import React from 'react';
import strings from 'utils/strings';
import AlertBox from 'components/CreateNotification/alert';
import transferSubTestResults from 'api/transferSubTestResults';

class TransferSubTestModel extends React.Component {
	constructor(props) {
		super(props);

		// selectedIds comes as an array from props
		const selectedIds = this.props.selectedIds || [];

		this.state = {
			selectedIds: selectedIds,
			testKey: '', // user enters this manually
			showAlert: false,
			success: null,
			message: '',
			isConfirmedDisabled: false,
		};
	}

	//----------------------------------------------------
	// CONFIRM → SEND TRANSFER REQUEST
	//----------------------------------------------------
	onConfirm = () => {
		const {selectedIds, testKey} = this.state;

		if (!testKey.trim()) {
			this.setState({
				showAlert: true,
				success: false,
				message: strings.pleaseEnterValidTestKey,
			});
			return;
		}

		this.setState({isConfirmedDisabled: true});

		transferSubTestResults({
			selectedIds,
			testKey,
		}).then((res) => {
			if (!res) {
				this.setState({
					showAlert: true,
					success: false,
					message: strings.opsSomethingWentWrongCap,
				});
			} else {
				// Refresh parent table
				this.props.getTestsBySearch({testKey});

				this.setState({
					showAlert: true,
					success: true,
					message: strings.subtestsTransferredSuccessfully,
				});
			}

			setTimeout(() => {
				this.setState({showAlert: false});
				this.props.onEditModelConfirm();
			}, 3000);
		});
	};

	//----------------------------------------------------
	// CANCEL MODAL
	//----------------------------------------------------
	onCancel = () => {
		this.props.onEditModelCancel();
		this.setState({
			showAlert: false,
			success: null,
			message: '',
		});
	};

	//----------------------------------------------------
	// RENDER UI
	//----------------------------------------------------
	render() {
		const {showAlert, message, success, testKey} = this.state;

		return (
			<div
				className="lit-modal"
				onClick={() => this.props.onEditModelCancel()}
			>
				<div
					className="lit-modal__other"
					onClick={(event) => event.stopPropagation()}
				>
					<div>
						<h3>{strings.transferSubtestsTitle}</h3>
					</div>

					{/* TEST KEY INPUT FIELD */}
					<div style={{marginBottom: '15px'}}>
						<label style={{fontWeight: 500}}>{strings.enterTestKeyLabel}</label>
						<input
							type="text"
							value={testKey}
							onChange={(e) =>
								this.setState({testKey: e.target.value})
							}
							style={{
								width: '100%',
								padding: '8px',
								marginTop: '5px',
								borderRadius: '6px',
								border: '1px solid #ccc',
							}}
							placeholder="e.g. 9VPXDE9B"
						/>
					</div>

					{/* ACTION BUTTONS */}
					<div className="lit-post-notification-btn-div">
						<button
							className="lit-btn bg-primary"
							onClick={this.onConfirm}
						>
							{strings.confirm}
						</button>

						<button
							className="lit-btn bg-negative"
							onClick={this.onCancel}
						>
							{strings.cancel}
						</button>
					</div>

					{/* ALERT MESSAGE */}
					{showAlert && (
						<AlertBox
							type={success ? 'success' : 'error'}
							message={message}
						/>
					)}
				</div>
			</div>
		);
	}
}

export default TransferSubTestModel;
